import React from 'react';
import SplitButton from '../ui/SplitButton';

function SignatureStateIcon({ on }) {
    return (
        <svg aria-hidden="true" width="16" height="16" viewBox="0 0 20 20" fill="none">
            {on
                ? <path d="m4 10 4 4 8-8" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                : <path d="m5 5 10 10M15 5 5 15" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />}
        </svg>
    );
}

export default function SignatureChip({ chip }) {
    if (!chip) return null;
    const { on, disabled, title, state, onToggle, personalPart, setupHref } = chip;
    const noPersonal = state === 'none';
    const statusLabel = on ? 'Signature on' : 'Signature off';
    const personalSignatures = Array.isArray(chip.personalSignatures)
        ? chip.personalSignatures
        : (personalPart ? [{ key: 'personal', text: personalPart }] : []);
    const signatureOptions = !personalSignatures.length
        ? [{ key: 'no-personal', label: 'No personal signature is set.', displayOnly: true }]
        : !on
            ? [{ key: 'personal-off', label: 'Personal signature is off for this message.', displayOnly: true }]
            : personalSignatures.map((signature, index) => ({
                key: signature.key || `personal-${index}`,
                label: signature.label || signature.text || '',
                title: 'Personal signature added to this message',
                onSelect: () => {},
                className: 'ia-signature-preview-pill',
            }));
    if (noPersonal && setupHref) {
        signatureOptions.push({ key: 'setup', label: 'Set up your signature', href: setupHref });
    }
    const options = [{
        key: 'signatures',
        label: 'Signatures',
        options: signatureOptions,
        scrollable: true,
        // Comms next pass (5a): the personal signatures reveal to the RIGHT of the "Signatures" pill, anchored to that
        // pill (ActionPillMenu's per-parent anchoring); they only flip left when the right side truly has no room.
        placement: 'right',
        mobilePlacement: 'right',
    }];
    return (
        <div className="ia-signature-control" role="group" aria-label="Message signature" data-signature-chip={state}>
            <SplitButton
                variant="go"
                className="ia-signature-split"
                menuClassName="ia-signature-preview-menu"
                menuSide="primary"
                primaryLabel="Signature"
                primaryAriaLabel="Signature"
                primaryProps={{ title, 'data-signature-preview-trigger': 'true', 'data-signature-label': 'true' }}
                secondaryContent={(
                    <>
                        <SignatureStateIcon on={on} />
                        <span className="sr-only"> {on ? 'On' : 'Off'}</span>
                    </>
                )}
                secondaryAriaLabel={statusLabel}
                secondaryDisabled={disabled}
                onSecondaryClick={onToggle}
                secondaryProps={{ title, 'aria-pressed': on, 'data-signature-state': state, 'data-signature-toggle': 'true', 'data-signature-picker-trigger': 'true' }}
                menuTriggerLabel="Signature options"
                menuLabel="Signature options"
                menuOptions={options}
            />
        </div>
    );
}
